module.exports = __webpack_public_path__ + "static/media/FontsFree-Net-times-new-roman-italic.e3d6e9ea.ttf";